import React, { useRef, useEffect, useState } from 'react';
import {
  HeroContainer,
  WavyBackground,
  ContentContainer,
  Title,
  Subtitle,
  PhoneButtonContainer,
  CallingMessage,
  CallingText,
  AcronymSection,
  AcronymList,
  AcronymItem,
  AcronymLetter,
  AcronymText,
  DescriptionSection,
  DescriptionText,
  EnergyParticles,
  EnergyParticle,
  EnergyCircle,
  HighlightedWord
} from './ThankYouStyles';
import ChannelsComponent from './ChannelsSection';
import ProcessFlowSection from './ProcessFlowSection';
import PlatformVideoSection from './PlatformVideoSection';
import ActionButtons from './ActionButtons';
import ScheduleButtonSection from './ScheduleButtonSection';

const ThankYouSection = () => {
  const [isAcronymVisible, setIsAcronymVisible] = useState(false);
  const acronymRef = useRef(null);

  // Dados da sigla BIANCA
  const acronymData = [
    { letter: 'B', text: 'Bot de' },
    { letter: 'I', text: 'Inteligência' },
    { letter: 'A', text: 'Artificial para' },
    { letter: 'N', text: 'Nutrição e' },
    { letter: 'C', text: 'Controle de' },
    { letter: 'A', text: 'Agendamento' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsAcronymVisible(true);
        }
      },
      { 
        threshold: 0.6, // Ativa quando 60% da seção está visível
        rootMargin: "-10px" // Pequena margem negativa para garantir que está bem visível
      }
    );

    if (acronymRef.current) {
      observer.observe(acronymRef.current);
    }

    return () => {
      if (acronymRef.current) {
        observer.unobserve(acronymRef.current);
      }
    };
  }, []);

  // Gerar partículas de energia aleatórias
  const renderEnergyParticles = () => {
    const particles = [];
    const colors = ['#00FFFF', '#64B6FF', '#0080FF', '#FFFFFF'];
    const sizes = ['4px', '6px', '8px', '10px'];
    
    for (let i = 0; i < 20; i++) {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const size = sizes[Math.floor(Math.random() * sizes.length)];
      const duration = `${2 + Math.random() * 3}s`;
      const delay = `${Math.random() * 2}s`;
      
      particles.push(
        <EnergyParticle 
          key={i}
          top={top}
          left={left}
          color={color}
          size={size}
          duration={duration}
          delay={delay}
        />
      );
    }
    
    return particles;
  };

  return (
    <HeroContainer>
      <WavyBackground />
      <ContentContainer>
        <Title>
          <div className="logo-container">
            <div className="logo-tech-circle"></div>
            <div className="logo-tech-data"></div>
            <img src="/favicon.png" alt="Logo Bianca" className="title-logo" />
          </div>
          <div className="title-text-container">
            <div className="tech-data-top">// AI.AGENT</div>
            <span className="title-text">BIANCA</span>
            <div className="tech-data-bottom">{/* data.transform(leads) */}</div>
          </div>
        </Title>
        <Subtitle>
          Transformando leads em agendamentos
        </Subtitle>
        
        <PhoneButtonContainer>
          <CallingMessage>
            <CallingText>Obrigado, a Bianca está te ligando</CallingText>
          </CallingMessage>
        </PhoneButtonContainer>
        
        {/* Seção de explicação da sigla BIANCA */}
        <AcronymSection ref={acronymRef} isVisible={isAcronymVisible}>
          <AcronymList>
            {acronymData.map((item, index) => (
              <AcronymItem key={index} index={index} isVisible={isAcronymVisible}>
                <AcronymLetter isVisible={isAcronymVisible}>{item.letter}</AcronymLetter>
                <AcronymText index={index} isVisible={isAcronymVisible}>{item.text}</AcronymText>
              </AcronymItem>
            ))}
          </AcronymList>
        </AcronymSection>
        
        {/* Botão de agendamento após a seção do acrônimo */}
        <ScheduleButtonSection />
        
        {/* Seção de descrição da BIANCA */}
        <DescriptionSection>
          <EnergyParticles>
            {renderEnergyParticles()}
          </EnergyParticles>
          <EnergyCircle />
          <DescriptionText>
            BIANCA é uma agente de IA especializada em <HighlightedWord>maximizar</HighlightedWord> a conversão de <HighlightedWord>leads</HighlightedWord> em <HighlightedWord>agendamentos</HighlightedWord>
          </DescriptionText>
        </DescriptionSection>
        
        {/* Nova seção de canais de atendimento */}
        <ChannelsComponent />
        
        {/* Nova seção de fluxo de processo */}
        <ProcessFlowSection />
        
        {/* Nova seção de vídeo da plataforma */}
        <PlatformVideoSection />
        
        {/* Botões de ação */}
        <ActionButtons />
      </ContentContainer>
    </HeroContainer>
  );
};

export default ThankYouSection;
